import styled from 'styled-components';

interface InputBtnProps {
  name: string;
  type?: 'button' | 'submit' | 'reset'; // type 속성을 선택적으로 추가
  onClick?: () => void;
}

export const InputBtn = ({ name, type = 'button', onClick }: InputBtnProps) => {
  return (
    <InputBtnBox>
      <button type={type} onClick={onClick}>
        {name}
      </button>
    </InputBtnBox>
  );
};

// styled
const InputBtnBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 2rem 3.2rem;
  background-color: ${(props) => props.theme.textWhiteColor};
  button {
    width: 100%;
    background-color: ${(props) => props.theme.btnBlueColor};
    color: ${(props) => props.theme.textWhiteColor};
    padding: 1.7rem;
    border-radius: 1.2rem;
    border: 0;
    outline: none;
    font-size: 1.8rem;
    font-weight: 600;
  }
`;
